<template>
    <div>
        <div class="modal hide fade" id="modalReturnList" tabindex="-1" role="dialog" aria-labelledby="modalReturnList" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Retur List
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive">
                            <div class="form-inline ml-auto">
                              <div class="button-group">
                                <button type="button" class="btn btn-hard-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                                    <i class="fa fa-filter" aria-hidden="true"></i>
                                    Filter
                                    <span class="caret"></span>
                                </button>
                                <ul class="dropdown-menu p-2" >
                                    <!-- <span>Company:</span> -->
                                    <!-- <li><a href="#" class="small" tabIndex="-1"><input type="checkbox" :value="c.company_no" v-model="filterCompany"/>&nbsp; {{ c.name }}</a></li> -->
                                </ul>
                                <button type="button" class="btn btn-sm  btn-soft-outline-primary waves-light waves-effect" @click="refreshList">
                                    <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                                </button>
                                rows:
                                <select id="select-rows" v-model="pageSize" @change="setPageSizeOnChange">
                                    <option v-for="r in rowsTable" :key="r.row" :value="r.row">{{ r.row }}</option>
                                </select>
                                <span class="mr-1">
                                    Total rows: <b>{{ filterData.length }}</b>
                                </span>
                                <date-picker v-model="startDate" type="date" range placeholder="Select date range" @change="refreshList"></date-picker>
                              </div>
                              <div class="form-group mx-sm-3 mb-2">
                                  <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                              </div>
                              <span class="mr-1">{{ currentPage }} / {{ pageLength }}</span>
                              <nav aria-label="Page navigation example" class="pull-right">
                                  <ul class="pagination">
                                      <li class="page-item">
                                          <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                              <i class="fa fa-angle-left" aria-hidden="true"></i>
                                          </a>
                                      </li>
                                      <li class="page-item">
                                          <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                              <i class="fa fa-angle-right" aria-hidden="true"></i>
                                          </a>
                                      </li>
                                  </ul>
                              </nav>
                            </div>
                            <table class="table table-item mb-0 table-sm table-hover">
                                <thead>
                                    <th>Status</th>
                                    <th>Type</th>
                                    <th>Return No</th>
                                    <th>Date</th>
                                    <th>Customer</th>
                                    <th class="text-right">Total</th>
                                </thead>
                                <tbody>
                                    <tr v-for="r in filterData" :key="r.id" @click="selectRetur(r)" style="cursor: pointer;" data-dismiss="modal">
                                      <td>
                                        <span class="badge badge-success" v-if="r.status === 'approve'">{{ r.status }}</span>
                                        <span class="badge badge-warning" v-else>{{ r.status }}</span>
                                      </td>
                                      <td>
                                        <span class="badge badge-success" v-if="r.type === 'sales'">{{ r.type }}</span>
                                        <span class="badge badge-warning" v-else>{{ r.type }}</span>
                                      </td>
                                      <td><b>{{ r.return_no }}</b></td>
                                      <td>{{ r.return_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ r.customer }}</td>
                                      <td class="text-right">{{ r.total | currency }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker'

export default {
  name: 'ReturnListModal',
  components: {
    DatePicker
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      filterCompany: [],
      startDate: [date1, date2],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Status',
        prop: 'status',
        align: 'text-left'
      }, {
        name: 'Type',
        prop: 'type',
        align: 'text-left'
      }, {
        name: 'Category',
        prop: 'category',
        allign: 'text-left'
      }, {
        name: 'Return No.',
        prop: 'return_no',
        align: 'text-left'
      }, {
        name: 'Date',
        prop: 'return_date',
        align: 'text-left'
      }, {
        name: 'Purchasing No.',
        prop: 'purchasing_no',
        align: 'text-left'
      }, {
        name: 'Company',
        prop: 'company_no',
        align: 'text-left'
      }, {
        name: 'Vendor',
        prop: 'vendor',
        align: 'text-left'
      }, {
        name: 'Note',
        prop: 'notes',
        align: 'text-left'
      }, {
        name: 'Total',
        prop: 'total',
        align: 'text-right'
      }, {
        name: 'Total Journal',
        prop: 'total_journal',
        align: 'text-right'
      }],
      selectAll: false,
      selected: []
    }
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      returList: state => state.returs.returList
    }),
    totalRetur () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalJournal () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total_journal)
      }
      return sum
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.returList.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        if (this.filterCompany.length > 0) {
          var array = this.filterCompany
          for (let i = 0; i < array.length; i++) {
            console.log(array[i])
            if (d.company_no === array[i]) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var payload = '?begin=' + begin + '&end=' + end + '&type=sales'
      this.$store.dispatch('getReturList', payload)
    },
    selectRetur (retur) {
      this.$emit('getRetur', retur)
    }
  }
}
</script>
